import { render, staticRenderFns } from "./valuable-cargo.vue?vue&type=template&id=6d9feb56&"
import script from "./valuable-cargo.vue?vue&type=script&lang=js&"
export * from "./valuable-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports